import './hiddenStyles.css';
export const hiddenFrameClassName = 'hiddenFrame';
